import React from 'react'

const Banner = (props) => {
  return (
    <section className='Banner'>
      <div className='container'>
        <div className='banner_img_holder'>
          <img src={props?.imgSrc} className='banner_img'/>
        </div>
      </div>
    </section>
  )
}

export default Banner
